(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  algolia.render = (template, container, data) => {
   
    return render(template(html, data), container);
  };

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    buildQuickBuyClass: function buildQuickBuyClass(data){
     
      var classList = '';

      if (data.available){
          var classList = 'product-quick_buy_option';
      } else {
          var classList = 'product-quick_buy_option quick_buy_option_disabled';
      }

     
      return classList;
    },
    buildProductImages: function buildProductImages(hit){
     
      var html = '';
      if (hit.meta.product.first_image.data.length > 0){
        console.log("product images:", hit.meta.product.first_image.data.length)
         var class_swap = "has-secondary-image-swap"
         for(i = 0; i < hit.meta.product.first_image.data.length; i++ ) {
          html += `
           <img alt="${hit.title}"
                 class="fade-in-from-left swap--visible secondary"
                 data-flickity-lazyload-src="https:${hit.meta.product.first_image.data[i]}"
                 data-sizes="auto"
                 data-flickity-lazyload-srcset="https:${hit.meta.product.first_image.data[i]}"
                 srcset="//www.gluestore.com.au/cdn/shop/t/782/assets/Loading_Image_Grey.jpg?v=160628682015187744921746158595"
                 height=""
                 width=""
                 style=""
           />
          `
         }
         const product_container = document.querySelector(`.product_algolia_${hit.id}.product-image__wrapper`)
         
          if (product_container){
            product_container.classList.add('has-secondary-image-swap');
          }
        }
        const parentElement_image = document.querySelector(`.product_algolia_${hit.id} .image-element__wrap.second_image_algolia`);
        if (parentElement_image){
          if (!parentElement_image.innerHTML.trim()){
            parentElement_image.insertAdjacentHTML('beforeend', html);
          }
           $(parentElement_image).flickity({
             pageDots: false,
             draggable: true,
             lazyLoad: 1
           });
        }
          
      return  html;
    },
    OnSale: function OnSale(data){
      var class_sale = ''
      var onSale = data.compare_at_price > data.price;
      if (onSale){
        class_sale = 'sale'
      }
      return class_sale;
    },
    
    getVariants: async function getVariants(productId) {
      console.log(productId)
      
      return new Promise(function (resolve, reject) {
        if (!productId) {
          reject(new Error("No productId provided"));
          return;
        }
    
        var url_2 = `${window.location.origin}/products/${productId}.json`;
        
        $.ajax({
          method: "GET",
          url: url_2,
          headers: {
            'Content-Type': 'application/json'
          },
          success: function (data) {
            //console.log("here data fetch", data);
            resolve(data.product);
            console.log("here mb")
          },
          error: function (error) {
            console.error("Error fetching product", error);
            reject(error);
          }
        });
      });


    },
    
    displayPrice: function displayPrice(item, distinct) {
     
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formatPrice(item.price);
    },
    itemDiscount: function itemDiscount(price, compare_at_price) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { 
        return 'orange_price_search' 
      }
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { return formatPrice(compare_at_price) }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `- ${Math.floor(discount_ratio * 100)} %`}
    },
    instantsearchLink: function instantsearchLink(hit) {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id;
      return (
        '/products/' +
        hit.handle +
        (addVariantId ? '?variant=' + hit.objectID : '')
      );
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return (res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : (item.image || item.featured_image);
      if (!image) {
        const placeholderImageURL = `//www.gluestore.com.au/cdn/shop/t/782/assets/Loading_Image_Grey.jpg?v=160628682015187744921746158595`;
  
        return `https:`+ `${placeholderImageURL}`;
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },

    sizedImage_slider: function sizedImage_slider(sizeInput, item) {
      var image = item;
      if (!image) {
        const placeholderImageURL = `//www.gluestore.com.au/cdn/shop/t/782/assets/Loading_Image_Grey.jpg?v=160628682015187744921746158595`;
  
        return `https:`+ `${placeholderImageURL}`;
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }
   
    
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        var image = item.distinct ? item.product_image : item.image;

        if (!image) {
          const placeholderImageURL = `//www.gluestore.com.au/cdn/shop/t/782/assets/Loading_Image_Grey.jpg?v=160628682015187744921746158595`;
  
          return `https:`+ `${placeholderImageURL}`;
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliaShopify);
